import React, { useContext, useEffect, useState, useRef } from 'react'
import { dataContext, localestr, itemToText, toText, getIrgValue, getIrgValueLast, uid, loaddat } from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js'
import Menu from '../cmp/menu'
import Panel from '../cmp/Panel'
import UniTable from '../cmp/UniTable'
import FilterForm from '../cmp/FilterForm' //+
import Docum from '../cmp/Docum' //+
import icon from '../icons.svg'
//import { click } from '@testing-library/user-event/dist/click.js'

let loading = false

let buffer = ''
let timer = null
let findDlg = false

function DocSupplyEdit({ data, actions }) {
  const targetRef = useRef()

  let wndData = {}
  if (data) wndData = data.wndData
  else wndData = actions.getWndData()
  const setWndData = actions.setWndData
  const tabNew = actions.tabNew
  const tabClose = actions.tabClose
  const tblPos = actions.tblPos  //Таблиця
  const isActive = actions.isActive  //Таблиця
  const setGlData = actions.setGlData
  const getGlData = actions.getGlData

  const context = useContext(dataContext)
  const getData = context.getData
  //const saveData=context.saveData
  const addTWnd = context.addTWnd
  const msg = context.msg
  const loaddata = context.loaddata
  const inputNumber = context.inputNumber
  const inputWeight = context.inputWeight
  const inputExcise = context.inputExcise
  const getSettings = context.getSettings
  const setSettings = context.setSettings
  const usersettings = getSettings().docSupplyEdit
  const inputCols = context.inputCols
  const msg_arr = context.msg_arr
  const setLoginData = context.setLoginData

  //const Data=context.data['catTables']
  const selUnitType = context.data['selUnitType']
  const selectionType = getSettings().selectionType || '0'
  const catGoods = context.data['catGoods'] || []
  const catDepartments = context.data['catDepartments']
  const gems = parseInt(context.data['sysConst']['gems'] || 0)
  let balance = undefined
  if (wndData) balance = wndData.balance
  const urAdmin = parseInt((context.user || {}).urAdmin || 0)
  const isAuthor = (context.user || {}).id === (wndData.author || {}).id
  let posted = parseInt(wndData.posted || 0) && !urAdmin
  let minDate = (new Date()).toISOString()
  if ((context.user || {}).rights?.urDocs3Edit) {
    let d = new Date()
    d.setDate(d.getDate() - 3)
    if (minDate > d.toISOString()) minDate = d.toISOString()
  }
  if ((context.user || {}).rights?.urDocs7Edit) {
    let d = new Date()
    d.setDate(d.getDate() - 7)
    if (minDate > d.toISOString()) minDate = d.toISOString()
  }
  if ((context.user || {}).rights?.urDocsREdit) {
    if (context.last_rev && context.last_rev < minDate) minDate = context.last_rev
  }
  if (urAdmin) {
    let d = new Date()
    d.setDate(d.getDate() - 1095) // 3 роки взад
    if (minDate > d.toISOString()) minDate = d.toISOString()
  }
  if (posted) {
    if (wndData.date && wndData.date > minDate) {
      if (isAuthor && (context.user || {}).rights?.urDocsOEdit) posted = false  // автор може редагувати свої документи, але врахувати останню ревізію чи дату
      if ((context.user || {}).rights?.urDocsSEdit) posted = false  // автор може редагувати чужі документи, але врахувати останню ревізію чи дату
    }
  }

  //const [edit, setEdit] = useState(false)
  const edit = (getGlData() || {}).edit
  const setEdit = (d) => { setGlData({ edit: d }) }
  const [isActive2, setisActive] = useState(false)
  const cols = [
    { caption: '№', minWidth: '20', maxWidth: '25', dataId: 'docum', sortable: false, typeVal: 'submit', setFn: (d) => { saveValue(d) } },
    //{caption:'№',minWidth:'40',dataId:'id',sortable:true},
    { caption: localestr('Товар'), minWidth: '130', dataId: 'good', sortable: true, typeVal: 'catGoods', setFn: (d) => { setVal('good', d) } },
    { caption: localestr('Од.'), minWidth: '30', maxWidth: '45', dataId: 'unit', sortable: true },
    { caption: localestr('К-сть'), minWidth: '42', maxWidth: '75', dataId: 'sum_qtt', sortable: true, typeVal: 'number3', setFn: (d) => { setVal('sum_qtt', d) } },
    { caption: localestr('Ціна'), minWidth: '105', maxWidth: '110', dataId: 'sum_prc', sortable: true, typeVal: 'number2', analise_data: 'last_prc', setFn: (d) => { setVal('sum_prc', d) } },
    { caption: localestr('Сума'), minWidth: '52', maxWidth: '100', dataId: 'sum_amount', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sum_amount', d) } },
    { caption: localestr('Поточний залишок'), minWidth: '52', maxWidth: '100', dataId: 'sum_bal', sortable: true },
  ]
  if (context.data['sysConst'] && parseInt(context.data['sysConst'].constExciseMark || 0)) cols.splice(2, 0, { caption: localestr('Акц. марки'), minWidth: '100', maxWidth: '120', dataId: 'ex_marks', sortable: true })

  if (usersettings && usersettings.cols) {
    for (let i = 0; i < usersettings.cols.length; i++) {
      const idx = cols.findIndex(el => el.dataId === usersettings.cols[i])
      if (idx !== -1) cols[idx].hiden = true
    }
  }

  const filterData = [
    { caption: localestr('Товар'), dataId: 'good', typeVal: 'catGoods' },
    { caption: localestr('К-сть'), dataId: 'sum_qtt', typeVal: 'number' },
    { caption: localestr('Ціна'), dataId: 'sum_prc', typeVal: 'number' },
    { caption: localestr('Сума'), dataId: 'sum_amount', typeVal: 'number' },
  ]

  const setFilter = (id, val, type) => {
    let filter = [...(wndData.filter || [])]
    const idx = filter.findIndex(el => el.dataId === id)
    if (idx !== -1) {
      if (!val) filter.splice(idx, 1)
      else filter[idx].value = val
    } else if (val) filter.push({ dataId: id, compare: 'lk', value: val, typeVal: type })
    if (!filter.length) filter = undefined
    setWndData({ ...wndData, filter, currentCol: undefined })
    setGlData({ needFocus: 1 })
    tblPos(0)
  }

  const showHideFilter = () => {
    const showAFilter = !wndData.showAFilter
    if (!showAFilter) setWndData({ ...wndData, filter: undefined, showAFilter })
    else setWndData({ ...wndData, showAFilter })
  }

  const get_balance = (item, balance, department) => {
    let newItem = { ...item }
    if (!balance) return newItem
    const idx = balance.findIndex(x => x.good === parseInt(item.good.id))
    if (idx !== -1) {
      newItem.sum_bal = balance[idx].qtt === 0 ? '' : balance[idx].qtt.toFixed(3)
      if (department && department.id) newItem.sum_bal = ''
      newItem.title = null
      for (let i = 0; i < balance[idx].deps.length; i++) {
        let idx2 = -1
        const dep = balance[idx].deps[i]
        if (department && parseInt(department.id) === dep.dep) newItem.sum_bal = dep.qtt.toFixed(3)
        let acc = ''
        if (dep.acc === '281') acc = ' (' + localestr('товар') + ')'
        if (dep.acc === '260') acc = ' (' + localestr('продукція') + ')'
        if (dep.acc === '250') acc = ' (' + localestr('нанівфабрикат') + ')'
        if (catDepartments) idx2 = catDepartments.findIndex(x => parseInt(x.id) === dep.dep)
        if (idx2 !== -1) {
          if (newItem.title) newItem.title += "\n" + catDepartments[idx2].name + ' :  ' + dep.qtt + ' ' + (newItem.unit || { name: '' }).name + acc
          else newItem.title = catDepartments[idx2].name + ' :  ' + dep.qtt + ' ' + (newItem.unit || { name: '' }).name + acc
        } else {
          if (newItem.title) newItem.title += "\n" + dep.dep + ' :  ' + dep.qtt + ' ' + (newItem.unit || { name: '' }).name + acc
          else newItem.title = '' + dep.dep + ' :  ' + dep.qtt + ' ' + (newItem.unit || { name: '' }).name + acc
        }
      }
    }
    return newItem
  }

  const listFromData = (currentCol, setCurrCol) => {
    let balance = []
    if (wndData.balance) balance = wndData.balance
    let list = []
    if (wndData.balance) balance = wndData.balance
    if (wndData.table) list = wndData.table.map((item) => {
      let newItem = {
        uid: uid(),
        id: item.id,
        good: { id: item.good_id, name: item.good, type: item.type, parent: { id: item.good_pid }, obj_type: 'catGoods' },
        unit: selUnitType.find(x => x.value === item.unit),
        sum_qtt: item.qtt,
        sum_amount: item.amount,
        sum_prc: item.price,
        last_prc: item.last_prc,
        ex_marks: item.marks
      }
      newItem = get_balance(newItem, balance, wndData.department)
      if (item.edit) newItem.edit = true
      if (typeof currentCol !== 'undefined' && currentCol.id === item.id) setCurrCol(newItem)
      return newItem
    })
    return list
  }

  const sortList = (col, sort, list) => {
    let needUpd = false
    let currentCol = wndData.currentCol
    if (typeof list === 'undefined') { list = listFromData(currentCol, newCol => currentCol = newCol); needUpd = true }
    else if (typeof wndData.list === 'undefined') { list = listFromData(currentCol, newCol => currentCol = newCol); needUpd = true }
    else list = wndData.list.slice()

    list.sort((a, b) => {
      let vala = toText(a[col])
      let valb = toText(b[col])
      if (col === 'id') {
        vala = parseInt(vala)
        valb = parseInt(valb)
      } else if (col === 'date') {
        vala = (a[col])
        valb = (b[col])
      } else if (col.substring(0, 4) === 'sum_') {
        vala = parseFloat(a[col] || 0)
        valb = parseFloat(b[col] || 0)
      } else {
        vala = vala.toLowerCase()
        valb = valb.toLowerCase()
      }
      if (sort === 'asc') {
        if (vala < valb) { needUpd = true; return -1 }
        if (vala > valb) return 1
        return 0
      } else if (sort === 'desc') {
        if (vala < valb) return 1
        if (vala > valb) { needUpd = true; return -1 }
        return 0
      } else return 0
    })
    const sorting = { dataId: col, sort: sort }
    if (needUpd || wndData.sorting.dataId !== col || wndData.sorting.sort !== sort) setWndData({ ...wndData, list, sorting, currentCol })
  }

  const setHidenCols = (data) => {
    if (data) {
      const new_data = data.filter(el => el.hiden).map(el => el.dataId)
      setSettings({ docSupplyEdit: { cols: new_data } })
    } else {
      if (edit) return
      inputCols(cols, setHidenCols)
    }
  }

  const setCol = (currentCol) => {
    if (!posted) setisActive(true)
    if (wndData.currentCol) if (currentCol.uid === wndData.currentCol.uid) return
    if ((getGlData() || {}).edit) { saveValue(() => { setCol(currentCol) }); return }
    //const list=wndData.list
    //const sorting=wndData.sorting
    //setWndData({...wndData,currentCol})
    const oldCol = { ...currentCol }
    setWndData({ ...wndData, currentCol, oldCol })
    setGlData({ needFocus: 0 })
  }

  const setVal = (name, data) => {
    let currentCol = wndData.currentCol
    if (name === 'sum_qtt_w') name = 'sum_qtt'
    if (currentCol[name] === data) return
    currentCol[name] = data
    if (name === 'good') {
      if (typeof (data.unit) !== 'object') currentCol[name].unit = selUnitType.find(x => x.value === data.unit)
      let sum_prc = parseFloat(data.sum || 0)
      if (data.price_history) sum_prc = parseFloat(getIrgValue(wndData.date, data.price_history) || 0)
      const sum_qtt = parseFloat(currentCol.sum_qtt || 1)
      const sum_bruto = sum_prc * sum_qtt
      if (typeof data.unit === 'object') currentCol.unit = data.unit
      else currentCol.unit = selUnitType.find(x => x.value === data.unit)
      currentCol.sum_prc = sum_prc.toFixed(2)
      currentCol.sum_qtt = sum_qtt.toFixed(3)
      currentCol.sum_amount = sum_bruto.toFixed(2)
      if (data.price_history) currentCol.last_prc = parseFloat(getIrgValueLast(wndData.date, data.price_history) || 0)
      else currentCol.last_prc = currentCol.sum_prc
      let balance = []
      if (wndData.balance) balance = wndData.balance
      currentCol = get_balance(currentCol, balance, wndData.department)
    } else if (name === 'sum_qtt') {
      const sum_prc = parseFloat(currentCol.sum_prc || 0)
      const sum_qtt = parseFloat(data || 0)
      const sum_bruto = sum_prc * sum_qtt
      currentCol.sum_amount = sum_bruto.toFixed(2)
    } else if (name === 'sum_prc') {
      const sum_prc = parseFloat(data || 0) || 0
      const sum_qtt = parseFloat(currentCol.sum_qtt || 0)
      const sum_bruto = sum_prc * sum_qtt
      //if(parseFloat(data||0)) currentCol.sum_prc=sum_prc.toFixed(2)
      currentCol.sum_amount = sum_bruto.toFixed(2)
    } else if (name === 'sum_amount') {
      const sum_bruto = parseFloat(data || 0)
      const sum_qtt = parseFloat(currentCol.sum_qtt || 0)
      let sum_prc = parseFloat(currentCol.sum_prc || 0)
      if (sum_qtt) sum_prc = sum_bruto / sum_qtt
      currentCol.sum_prc = sum_prc.toFixed(2)
      //currentCol.sum_amount=sum_bruto.toFixed(2)
    }
    setWndData({ ...wndData, currentCol })
    setEdit(true)
  }

  const cancelEdit = () => {
    if (!isActive()) return
    setEdit(false)
    setisActive(false)
    setGlData({ lastCol: 0, needFocus: 0 })
    const newData = actions.getWndData()
    if (newData.oldCol) {
      newData.currentCol = { ...newData.oldCol }
      newData.oldCol = undefined
      newData.list = newData.list.map(el => el.uid !== newData.currentCol.uid ? el : { ...newData.currentCol })
      setWndData(newData)
    } else {
      const list = newData.list.filter(el => el.uid !== newData.currentCol.uid)
      setWndData({ ...wndData, list, currentCol: undefined, oldCol: undefined })
    }
  }

  const filter = (fltr) => {
    let showFilter = !wndData.showFilter
    let filter = wndData.filter
    if (fltr !== undefined) filter = fltr
    if (showFilter || fltr === undefined) setWndData({ ...wndData, showFilter, filter })
    else {
      setWndData({ ...wndData, showFilter, filter, currentCol: undefined })
      setGlData({ needFocus: 1 })
      tblPos(0)
    }
  }

  const setValue = (name, data) => {
    if (posted) return
    setisActive(false)
    let newData = { ...wndData }
    // перевірити чи дата у минулому більше за 90 днів
    // перевірити чи дата у майбутньому
    if (name === 'date') {
      const currentDay = new Date();
      currentDay.setHours(23, 59, 59, 99);
      const inputDay = new Date(data);
      if (inputDay > currentDay) msg(localestr("Цей день ще не настав!"), localestr('Попередження'), [{ caption: 'OK', action: () => { } }]);
      else if ((currentDay - inputDay) / (1000 * 60 * 60 * 24) > 90) msg(localestr("У вас дуже стара дата!"), localestr('Попередження'), [{ caption: 'OK', action: () => { } }]);
    } else if (name === 'fiscal') {
      if (data && data.id && data.device?.value !== '4' && data.device?.value !== '5') {
        msg(localestr("Цей пристрій не є фіскальним реєстратором!"), localestr('Попередження'), [{ caption: 'OK', action: () => { } }])
        return
      }
    }
    if (data === '') newData[name] = null
    else newData[name] = data
    if (!newData.edit) newData.edit = true
    if (name === 'department') {
      let balance = []
      if (wndData.balance) balance = wndData.balance
      let list = wndData.list.map(item => {
        return get_balance(item, balance, newData.department)
      })
      newData.list = list
    }
    setWndData(newData, true)
  }

  const saveValue = (act = null) => {
    if (!isActive()) return
    let errmsg = ''
    const currCol = { ...wndData.currentCol, edit: true }
    const list = wndData.list
    if (!currCol) return
    if (!currCol.good) errmsg = localestr("Не заповнено товар")
    if (!currCol.sum_qtt && !currCol.sum_bruto) errmsg = localestr("Не заповнено кількість або суму")
    if (errmsg !== '') msg(errmsg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
    else {
      currCol.sum_qtt = parseFloat(currCol.sum_qtt).toFixed(3)
      currCol.sum_prc = (parseFloat(currCol.sum_prc || 0) || 0).toFixed(2)
      currCol.sum_amount = (parseFloat(currCol.sum_amount || 0) || 0).toFixed(2)
      const idx = list.findIndex(el => el.uid === currCol.uid)
      if (idx === -1) list.push(currCol)
      else list[idx] = currCol
      let newData = { ...wndData, list }
      setWndData(newData, true)
      setEdit(false)
      setisActive(false)
      if (act === -1) setGlData({ lastCol: 0, needFocus: 0 })
      else if (act) setTimeout(() => { act() }, 100)
      //setGlData({lastCol:0,needFocus:0})
    }
  }

  const newItem = () => {
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { newItem() }); return }
    //if (edit) return
    setisActive(true)
    let currentCol = { id: '', uid: uid() }
    const list = wndData.list.concat(currentCol)
    setWndData({ ...wndData, list, currentCol })
    setGlData({ lastCol: 0, needFocus: 0 })
    setEdit(true)
  }

  const copyItem = () => {
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { copyItem() }); return }
    //if (edit) return
    if (typeof wndData.currentCol === 'object') {
      setisActive(true)
      let currentCol = { ...wndData.currentCol, uid: uid() }
      delete currentCol.id
      const list = wndData.list.concat(currentCol)
      setWndData({ ...wndData, list, currentCol })
      setGlData({ needFocus: 0, lastCol: 0 })
      setEdit(true)
    }
  }

  const editItem = () => {
    return
    //Може це не треба
    /*if(posted) return
    if (edit) return
    if (!wndData.currentCol) return
    //setisActive(true)
    const currentCol={...wndData.currentCol}
    const oldCol={...wndData.currentCol}
    setWndData({...wndData,currentCol,oldCol})
    setEdit(true)*/
  }

  const editClick = () => {
    if (typeof wndData.currentCol === 'object') editItem()
  }

  const editMark = (d) => {
    if (posted) return
    if (!wndData.currentCol) return
    if (d === undefined) {
      if ((getGlData() || {}).edit) { saveValue(() => { editMark() }); return }
      //if (edit) return
      ex_marks_edit(wndData.currentCol.ex_marks, editMark)
    } else {
      const currentCol = { ...wndData.currentCol, ex_marks: d, edit: true }
      const list = wndData.list
      if (!currentCol) return
      const idx = list.findIndex(el => el.uid === currentCol.uid)
      if (idx === -1) return
      else list[idx] = currentCol
      let newData = { ...wndData, list, currentCol }
      setWndData(newData)
    }
  }

  const selectionClick = () => {
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { selectionClick() }); return }
    let curVall = undefined
    if (wndData.currentCol) curVall = wndData.currentCol.menu
    if (!curVall) addTWnd(localestr('Вибір'), 'catGoods_list', selectionProc, undefined, undefined, 2)
    else if (curVall.parent) addTWnd(localestr('Вибір'), 'catGoods_list', selectionProc, curVall, curVall.parent, 2)
    else addTWnd('Вибір', 'catGoods_list', selectionProc, curVall, undefined, 2)
  }

  const ex_marks_edit = (val, act) => {
    let is_liter = false
    if (wndData.currentCol && wndData.currentCol.unit && wndData.currentCol.unit.value === '3') is_liter = true
    inputExcise(localestr('Акцизні марки'), val, d => act(d), is_liter)
  }

  const selectionProc = (e, qtt, sum, ex_marks = undefined, amount = 0) => {
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { selectionProc(e, qtt, sum, ex_marks) }); return }
    //менюшка з вибором або в константах чи локально Тихий режим, Запитувати кількість, Запитувати кількість і ціну, Запитувати кількість і суму
    if (!qtt && parseInt(selectionType) > 0) {
      if (e.unit && (e.unit.value === '2' || e.unit === '2')) inputWeight(localestr('Кількість'), localestr('Кількість'), 1, (d) => { selectionProc(e, parseFloat(d || 0)) })
      else inputNumber(e.name || localestr('Кількість'), localestr('Кількість'), 1, (d) => { selectionProc(e, parseFloat(d || 0)) })
      return
    }
    if (!qtt) qtt = 1
    let newData = { ...wndData, findText: '', findArr: null }
    let list = newData.list
    let el = list.find(m => m.good?.id === e.id)
    if (!el) {
      let sum_prc = parseFloat(e.sum || 0)
      if (e.price_history) sum_prc = parseFloat(getIrgValue(wndData.date, e.price_history) || 0)
      if (!sum && parseInt(selectionType) === 2) { setTimeout(() => inputNumber(localestr('Ціна'), localestr('Ціна'), sum_prc, (d) => { selectionProc(e, qtt, parseFloat(d || 0)) }), 50); return }
      if (!sum && parseInt(selectionType) === 3) { setTimeout(() => inputNumber(localestr('Сума'), localestr('Сума'), sum_prc * qtt, (d) => { selectionProc(e, qtt, parseFloat(d || 0)) }), 50); return }
      if (parseInt(selectionType) > 0 && context.data['sysConst'] && parseInt(context.data['sysConst'].constExciseMark || 0) && parseInt(e.type) === 0 && ex_marks === undefined && !amount) { ex_marks_edit(null, d => selectionProc(e, qtt, sum, d)); return }
      if (sum && parseInt(selectionType) === 2) sum_prc = sum
      if (sum && parseInt(selectionType) === 3) sum_prc = sum / qtt || 1
      if (amount) sum_prc = amount / qtt || 1
      el = {
        uid: uid(),
        good: { ...e, obj_type: 'catGoods' },
        unit: e.unit,
        sum_qtt: qtt.toFixed(3),
        sum_amount: (sum_prc * qtt).toFixed(2),
        sum_prc: sum_prc.toFixed(2),
        edit: true
      }
      if (e.price_history) el.last_prc = parseFloat(getIrgValueLast(wndData.date, e.price_history) || 0)
      else el.last_prc = el.sum_prc
      if (typeof (el.unit) !== 'object') el.unit = selUnitType.find(x => x.value === el.unit)
      if (ex_marks) el.ex_marks = ex_marks
      let balance = []
      if (wndData.balance) balance = wndData.balance
      el = get_balance(el, balance, wndData.department)
      list.push(el)
    } else if (el.hide) {
      let sum_prc = parseFloat(e.sum || 0)
      if (e.price_history) sum_prc = parseFloat(getIrgValue(wndData.date, e.price_history) || 0)
      if (!sum && parseInt(selectionType) === 2) { setTimeout(() => inputNumber(localestr('Ціна'), localestr('Ціна'), sum_prc, (d) => { selectionProc(e, qtt, parseFloat(d || 0)) }), 50); return }
      if (!sum && parseInt(selectionType) === 3) { setTimeout(() => inputNumber(localestr('Сума'), localestr('Сума'), sum_prc * qtt, (d) => { selectionProc(e, qtt, parseFloat(d || 0)) }), 50); return }
      if (parseInt(selectionType) > 1 && context.data['sysConst'] && parseInt(context.data['sysConst'].constExciseMark || 0) && parseInt(e.type) === 0 && ex_marks === undefined && !amount) { ex_marks_edit(null, d => selectionProc(e, qtt, sum, d)); return }
      if (sum && parseInt(selectionType) === 2) sum_prc = sum
      if (sum && parseInt(selectionType) === 3) sum_prc = sum / qtt || 1
      if (amount) sum_prc = amount / qtt || 1
      const sum_qtt = qtt
      const sum_bruto = sum_prc * sum_qtt
      el.sum_prc = sum_prc.toFixed(2)
      el.sum_qtt = sum_qtt.toFixed(3)
      el.sum_amount = sum_bruto.toFixed(2)
      if (e.price_history) el.last_prc = parseFloat(getIrgValueLast(wndData.date, e.price_history) || 0)
      else el.last_prc = el.sum_prc
      el.hide = false
      if (ex_marks) el.ex_marks = ex_marks
      el.edit = true
    } else {
      let sum_prc = parseFloat(el.sum_prc || 0)
      const sum_qtt = parseFloat(el.sum_qtt || 0) + qtt
      let sum_bruto = sum_prc * sum_qtt
      if (!sum && parseInt(selectionType) === 3) { setTimeout(() => inputNumber(localestr('Сума'), localestr('Сума'), sum_prc * qtt, (d) => { selectionProc(e, qtt, parseFloat(d || 0)) }), 50); return }
      if (parseInt(selectionType) > 1 && context.data['sysConst'] && parseInt(context.data['sysConst'].constExciseMark || 0) && parseInt(e.type) === 0 && ex_marks === undefined && !amount) { ex_marks_edit(el.ex_marks, d => selectionProc(e, qtt, sum, d)); return }
      if (amount) { sum_bruto = parseFloat(el.sum_amount || 0) + amount; sum_prc = sum_bruto / sum_qtt || 1 }
      else if (sum && parseInt(selectionType) === 3) { sum_bruto = parseFloat(el.sum_amount || 0) + sum; sum_prc = sum_bruto / sum_qtt || 1 }
      el.sum_prc = sum_prc.toFixed(2)
      el.sum_qtt = sum_qtt.toFixed(3)
      el.sum_amount = sum_bruto.toFixed(2)
      if (e.price_history) el.last_prc = parseFloat(getIrgValueLast(wndData.date, e.price_history) || 0)
      else el.last_prc = el.sum_prc
      if (ex_marks) el.ex_marks = ex_marks
      el.edit = true
    }
    newData.currentCol = { ...el }
    newData.list = list
    if (newData.currFind !== undefined) {
      newData.currFind = undefined
      //Тут фокусування на пошуку 'search'
      setTimeout(() => {
        const el = document.getElementById('search')
        if (el) el.focus()
      }, 200)
    }
    setWndData(newData, true)
    setGlData({ needFocus: -2, lastCol: 0 })
  }

  const removeItem = () => {
    if (posted) return
    //if (edit) return
    if ((getGlData() || {}).edit) { saveValue(() => { removeItem() }); return }
    if (!wndData.currentCol) return
    const currCol = { ...wndData.currentCol, edit: true, hide: true }
    const list = wndData.list
    const idx = list.findIndex(el => el.uid === currCol.uid)
    if (idx === -1) return
    list[idx] = currCol
    let curIdx = idx + 1
    let currentCol = undefined
    for (let i = curIdx; i < list.length; i++) if (!list[i].hide) { currentCol = { ...list[i] }; break }
    if (!currentCol) for (let i = curIdx - 1; i > 0; i--) if (!list[i].hide) { currentCol = { ...list[i] }; break }
    let newData = { ...wndData, list, currentCol }
    setWndData(newData, true)
    setGlData({ needFocus: 0 })
  }

  const saveDoc = (d, close = true) => {
    if ((getGlData() || {}).edit) { saveValue(() => { saveDoc(d, close) }); return }
    if (d) {
      loading = false
      const status = d.status
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (wndData.update) wndData.update(d.data)
      if (close) tabClose(false)
      else {
        let currentCol = wndData.currentCol
        let table = []
        if (d.data.table) table = d.data.table.map(el => ({ id: el.id, uid: el.uid, good_id: el.good.id, good: el.good.name, good_pid: el.good.pid }))
        let list = wndData.list.filter(el => !el.hide)
        list = list.map(el => ({ ...el, edit: false }))
        /*for (let i = 0; i < list.length; i++) {
          if (!list[i].id) {
            const idx = table.findIndex(el => el.good_id === list[i].good.id)
            if (idx !== -1) list[i].id = table[idx].id
          }
        }*/
        for (let i = 0; i < table.length; i++) {
          let idx = list.findIndex(el => el.uid === table[i].uid)
          //if (idx === -1) idx = list.findIndex(el => el.good.id === table[i].good_id)
          if (idx !== -1) list[idx].id = table[i].id
        }
        if (currentCol && !currentCol.id) {
          const idx = table.findIndex(el => el.good_id === currentCol?.good?.id)
          if (idx !== -1) currentCol.id = table[idx].id
        }
        let newData = { ...wndData, list, currentCol, id: d.data.id, edit: false }
        setWndData(newData, false)
        setTimeout(loadData, 300)
      }
    } else {
      wndData = actions.getWndData()
      let data = {}
      if (wndData.edit) {
        let errmsg = ''
        if (!wndData.date) errmsg += localestr("Не заповнено дату документа")
        if (!wndData.counterpartie) errmsg += localestr("Не заповнено контрагента")
        if (!wndData.department) errmsg += localestr("Не заповнено підрозділ")
        if (parseInt(wndData.payed) && !wndData.cashAcc) errmsg += localestr("Не заповнено касу/рахунок")
        if (errmsg !== '') { msg(errmsg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
        if (wndData.id) data.id = wndData.id
        if (wndData.uid) data.uid = wndData.uid
        data.header = { author: wndData.author, date: wndData.date, in_num: (wndData.in_num || '').substring(0, 16), in_date: wndData.in_date, counterpartie: wndData.counterpartie, department: wndData.department, posted: wndData.posted, fiscal: { id: (wndData.fiscal || {}).id }, note: (wndData.note || '').substring(0, 85), docum: wndData.docum, payed: wndData.payed, cashAcc: { id: (wndData.cashAcc || {}).id }, article: { id: (wndData.article || {}).id } }
        if (wndData.marked !== '1' && wndData.marked !== 1) data.header.act = 'post'
        if (!wndData.author) data.header.author = { id: 'NULL' }
        if (!parseInt(wndData.payed)) { data.header.cashAcc = { id: 'NULL' }; data.header.article = { id: 'NULL' } }
      }
      let table = wndData.list.filter(el => el.edit)
      table = table.filter(el => !el.hide || el.id)
      if (table.length) {
        if (wndData.id) data.id = wndData.id
        if (wndData.uid) data.uid = wndData.uid
        //if(wndData.posted) data.posted=wndData.posted
        if (wndData.marked !== '1' && wndData.marked !== 1) if (!data.header) data.header = { act: 'post' }
        data.table = table.map(el => {
          let d = { uid: el.uid, good: { id: el.good.id }, qtt: el.sum_qtt, price: el.sum_prc, amount: el.sum_amount, marks: el.ex_marks }
          if (el.hide) d.act = 'del'
          if (el.id) d.id = el.id
          return d
        })
      }

      if (posted) {
        msg(localestr('Не достатньо прав для редагування цього документа'), localestr('Збереження'), [
          { caption: localestr('Відмінити'), action: () => { } },
          { caption: 'Закрити', action: () => { tabClose(false) } }
        ])
        return
      }

      if (Object.keys(data).length) {
        if (parseInt(wndData.posted)) data.posted = 1
        if (parseInt(wndData.marked)) data.marked = 1
      }

      if (loading) return
      loading = true
      setTimeout(() => { loading = false }, 5000)

      if (!close) {
        if (Object.keys(data).length) {
          data.header.act = '';
          loaddata('action=modSupply&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt, close) })
        }
        return
      }
      if (Object.keys(data).length && wndData.posted && parseInt(wndData.posted) > 0) msg(localestr('Зберегти зміни?'), localestr('Збереження'), [
        { caption: 'OK', action: () => { loaddata('action=modSupply&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt, close) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if (Object.keys(data).length && !parseInt(wndData.marked)) msg(localestr('Зберегти зміни?'), localestr('Збереження'), [
        { caption: localestr('Провести'), action: () => { loaddata('action=modSupply&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt, close) }) } },
        { caption: localestr('Зберегти'), action: () => { data.header.act = ''; loaddata('action=modSupply&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt, close) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if ((wndData.posted === '0' || wndData.posted === 0) && (wndData.marked !== '1' && wndData.marked !== 1)) msg(localestr('Провести документ?'), localestr('Проведення'), [
        { caption: localestr('Провести'), action: () => { loaddata('action=postSupply&data=' + encodeURIComponent(JSON.stringify({ id: wndData.id })), undefined, (dt) => { saveDoc(dt, close) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if ((wndData.marked !== '1' && wndData.marked !== 1)) msg(localestr('Провести документ?'), localestr('Проведення'), [
        { caption: localestr('Закрити'), action: () => { tabClose(false) } },
        { caption: localestr('Провести'), action: () => { loaddata('action=postSupply&data=' + encodeURIComponent(JSON.stringify({ id: wndData.id })), undefined, (dt) => { saveDoc(dt) }) } }
      ])
      else if (close) tabClose(false)
    }
  }

  const findItem = (val) => {
    const newData = { ...wndData, findText: val }
    findDlg = false
    newData.findArr = null
    if (val.length > 1) {
      const Arr = catGoods.filter(el => (el.id.indexOf(val) === 0 || (el.name || '').toLowerCase().indexOf(val.toLowerCase()) !== -1 || (el.barcode && el.barcode.indexOf(val) === 0)) && !parseInt(el.marked))
      if (Arr.length > 10) Arr.splice(10)
      newData.findArr = Arr
      if (Arr.length) findDlg = true
      else { newData.findArr = null; findDlg = false }
    }
    setWndData(newData)
  }

  const findClick = (el) => {
    const newData = { ...wndData, findText: '', findArr: null, currFind: -1 }
    findDlg = false
    setWndData(newData)
    selectionProc({ ...el })
  }

  const anyKey = (key) => {
    if (!isActive()) return
    if (key === 'Delete') removeItem()
    else if (key === 'Insert') newItem()
    else if (key === 'F9') copyItem()
    else if (key === 'Escape') cancelEdit()
    else if (key === 'shift_F4') tabClose()
    else if (key === 'F2') showHideFilter()
  }

  const objEntries = () => {
    if (wndData.id) {
      const item = { ...wndData, type: 'docSupply' }
      tabNew('repObjEntries', localestr('Проводки') + ' ' + itemToText(item), { object: item }, true)
    }
  }

  const weightClick = async () => {
    if (!edit) return
    if (!wndData.currentCol) return
    const w_type = localStorage.getItem('w_type')
    if (!w_type) {
      msg_arr(localestr('Виберіть модель ваг'), '', [{ caption: 'NT-15', action: () => { localStorage.setItem('w_type', 'NT-15'); weightClick() } }, { caption: 'Ягуар', action: () => { localStorage.setItem('w_type', 'Jaguar'); weightClick() } }])
      return
    }
    if ("serial" in navigator) {
      const ports = await navigator.serial.getPorts();
      let port = ports[0];
      if (!port) port = await navigator.serial.requestPort();
      if (w_type === 'NT-15') {
        try {
          await port.open({ baudRate: 4800, dataBits: 8, stopBits: 1, parity: 'even' });
        } catch (error) {
          console.log(error)
          return;
        }
        let timerId = setTimeout(() => port.close(), 3000)

        const writer = port.writable.getWriter();
        await writer.write(new Uint8Array([0]));
        await writer.write(new Uint8Array([0]));
        await writer.write(new Uint8Array([3]));
        writer.releaseLock();

        let w = '';

        while (port.readable) {
          const reader = port.readable.getReader({ mode: 'byob' });
          let timer2Id = setTimeout(() => reader.releaseLock(), 2000)
          try {
            while (true) {
              let buffer = new ArrayBuffer(16);
              const { value, done } = await reader.read(new Uint8Array(buffer));
              if (done) break;
              if (w.length < 6) {
                for (let i = 0; i < 6; i++) w = String.fromCharCode(value[i]) + w;
              }
              if (value.length < 8) break;
            }
          } catch (error) {
            // Handle |error|…
            console.log(error);
          } finally {
            reader.releaseLock();
            clearTimeout(timer2Id);
            await port.close();
            clearTimeout(timerId);
          }
        }
        setVal('sum_qtt_w', parseInt(w || 0) / 1000)
      } else if (w_type === 'Jaguar') {
        try {
          await port.open({ baudRate: 4800, dataBits: 8, stopBits: 1 });
        } catch (error) {
          console.log(error)
          return;
        }
        let timerId = setTimeout(() => port.close(), 3000)

        const writer = port.writable.getWriter();
        await writer.write(new Uint8Array([80]));
        writer.releaseLock();

        let w = '';

        while (port.readable) {
          const reader = port.readable.getReader({ mode: 'byob' });
          let timer2Id = setTimeout(() => reader.releaseLock(), 2000)
          try {
            while (true) {
              let buffer = new ArrayBuffer(16);
              const { value, done } = await reader.read(new Uint8Array(buffer));
              if (done) break;
              if (w.length < 6) {
                for (let i = 0; i < 6; i++) w += String.fromCharCode(value[i]);
              }
              if (value.length < 8) break;
            }
          } catch (error) {
            // Handle |error|…
            console.log(error);
          } finally {
            reader.releaseLock();
            clearTimeout(timer2Id);
            await port.close();
            clearTimeout(timerId);
          }
        }
        setVal('sum_qtt', parseFloat(w || 0))
      }
    }
  }

  const loadData = (d) => {
    if (d) {
      const status = d.status
      if (status === 'UsrChoise') { setLoginData(d); return }
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      wndData = actions.getWndData()
      let list = wndData.list.map(item => {
        return get_balance(item, d.data, wndData.department)
      })
      setWndData({ ...wndData, list, balance: d.data })
    } else {
      loaddat('action=balGoods', (dt) => { loadData(dt) })
    }
  }

  const needFocus = (reset = -1) => {   //Таблиця
    const glData = getGlData() || {}
    const needFocus = glData.needFocus
    const lastCol = glData.lastCol
    if (needFocus === -2) return -2
    if (isActive() === false) return -1
    if (needFocus === undefined) return -1
    if (reset === -1) setGlData({ needFocus: -1 })
    if (reset) setGlData({ needFocus: reset })
    if (reset > 0) setGlData({ lastCol: reset })
    if (needFocus === 0 && lastCol) return lastCol
    return needFocus
  }

  useEffect(() => {
    //loadData()
    if (typeof catDepartments === 'undefined') getData('catDepartments')
    if (wndData.sorting) sortList(wndData.sorting.dataId, wndData.sorting.sort, wndData.list)
    else sortList('name', 'asc', wndData.list)
    // eslint-disable-next-line 
  }, [wndData.table])

  useEffect(() => {
    if (context.data['sysConst'] === undefined) {
      context.getData('sysConst')
    }
    if (context.data['catGoods'] === undefined) {
      context.getData('catGoods')
    }
    if (balance === undefined) {
      loadData()
    }
  },)

  function setActive(el) {
    //це треба для сканера
    if (edit) return
    if (!el) return
    if (document.activeElement.nodeName === 'INPUT') return
    if (document.activeElement.id === 'doc_cont') return
    if (el.contains(document.activeElement)) return
    if (document.activeElement.nodeName === 'BODY') { setTimeout(() => { setActive(el) }, 200); return }
    el.focus()
  }
  //----------barcode---------
  const getSymbol = (e) => {
    if (e.target.tagName === 'INPUT') return
    if (e.key === 'Insert') { newItem(); return }
    if (edit) return
    if (e.key === 'Enter' || e.which === 13) {
      if (!buffer) return
      const items = catGoods.filter(el => el.barcode === buffer)
      if (items.length) {
        buffer = ''
        if (timer) clearInterval(timer)
        timer = null
        if (items.length > 1) {
          const msg_items = items.map(el => ({ caption: (el.parent.name || '') + ' / ' + el.name, action: () => selectionProc(el) }))
          msg_arr(localestr('Виберіть товар'), '', msg_items)
        }
        selectionProc(items[0])
        setTimeout(() => {
          const el = document.getElementById('doc_cont')
          if (el) el.focus()
        }, 200)
      }
      buffer = ''
      if (timer) clearInterval(timer)
      timer = null
      return
    }
    buffer += e.key
    if (!timer) timer = setInterval(() => buffer = '', 500)
  }

  const wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
  const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
  const showFilter = wndData.showFilter ? <FilterForm filterData={filterData} filter={wndData.filter} setFilter={filter} /> : ''  //+

  let ttlSum = 0
  wndDataList.forEach(el => {
    if (!el.good) return
    if (!el.hide) ttlSum += parseFloat(el.sum_amount)
  })
  if (ttlSum !== 0) ttlSum = <div style={{ alignSelf: 'self-end', fontWeight: 'bold', paddingRight: '2px' }}>{(window.innerWidth < 425 ? ' ' : localestr('Разом') + ': ') + ttlSum.toFixed(2)}</div>
  else ttlSum = ''

  let ex_btn = null
  if (context.data['sysConst'] && parseInt(context.data['sysConst'].constExciseMark || 0)) {
    if (wndData.currentCol && wndData.currentCol.good && parseInt(wndData.currentCol.good.type) === 0) {
      ex_btn =
        window.innerWidth < 425 ? (
          <div tabIndex='0' className='toolBarItem' title={localestr('Акцизні марки')}
            onClick={() => editMark()}
            onKeyUp={(e) => { if (e.key === 'Enter') editMark() }}><img src={icon + '#exBut'} alt={localestr('Акцизні марки')} /></div>
        ) : (
          <div tabIndex='0' onClick={() => { editMark() }} onKeyUp={(e) => { if (e.key === 'Enter') editMark() }}
            style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '148px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn135v) no-repeat', backgroundSize: '148px 30px', boxSizing: 'border-box' }}>
            <img style={{ width: '24px', height: '24px', verticalAlign: 'middle' }} src={icon + '#mark'} alt={localestr('Акцизні марки')} />&nbsp;
            {localestr('Акцизні марки')}
          </div>
        )
    }
  }

  const keyHandler = (e) => {
    if (e.key === 'ArrowUp' && wndData.findArr) {
      if (wndData.currFind === undefined || wndData.currFind === -1) setWndData({ ...wndData, currFind: 0 })
      else if (wndData.currFind === 0) setWndData({ ...wndData, currFind: wndData.findArr.length - 1 })
      else setWndData({ ...wndData, currFind: wndData.currFind - 1 })
    }
    else if (e.key === 'ArrowDown' && wndData.findArr) {
      if (wndData.currFind === undefined || wndData.findArr.length - 1 <= wndData.currFind) setWndData({ ...wndData, currFind: 0 })
      else setWndData({ ...wndData, currFind: wndData.currFind + 1 })
    }
    else if (e.key === 'Enter' && wndData.findArr && wndData.findArr.length) {
      if (wndData.currFind === -1 || wndData.currFind === undefined) return//findClick(wndData.findArr[0])
      e.target.blur()
      findClick(wndData.findArr[wndData.currFind])
    }
  }

  const aiFillProc = d => {
    console.log(d)
    if (d[0] === 1) setTimeout(() => setValue(d[1], d[2]), 200)
    if (d[0] === 2) setTimeout(() => setValue(d[1], d[2]), 400)
    if (d[0] === 3) selectionProc(d[1], d[2], d[3], d[4], d[5])

  }

  const aiFillClick = () => {
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { aiFillClick() }); return }
    let curVall = undefined //сюди треба передавати список товарів, папок, контрагентів
    //Функції створення товарів напевно у компоненті
    addTWnd('Заповнення', 'aiSupplyFill', aiFillProc, curVall, undefined, 2)
  }



  let findItems = null
  if (findDlg && wndData.findArr) {
    setTimeout(() => findDlg = false, 30000)
    const items = wndData.findArr.map((el, idx) => {
      let stl = { cursor: 'pointer', fontSize: 'small' }
      if (idx === wndData.currFind) stl.background = '#9E91F7'
      return (
        <div key={idx} style={stl} onClick={() => { findClick(el) }}>{(el.parent.name || '') + ' / ' + el.id + ' - ' + el.name}</div>
      )
    })
    findItems = <div className='no-print' style={{ right: '0px', top: '24px', width: '100%', position: 'absolute', background: '#FFFFFF', zIndex: '100' }}>
      {items}
    </div>
  }

  const menuData =
    window.innerWidth < 425 ? (
      [
        { name: localestr('Налаштування таблиці'), icon: '#b953', action: setHidenCols },
        { name: localestr('Фільтр'), icon: '#b955', action: filter },
        { name: localestr('Проводки документа'), icon: '#postBut', action: objEntries },
        //{ name: localestr('Копіювати'), icon: '#b952', action: copyItem },
        //{ name: localestr('Автофільтр'), icon: '#filtBut', action: showHideFilter },
        //{ name: localestr('Підбір'), icon: '#selBut', action: selectionClick },
      ]) : (
      [
        { name: localestr('Налаштування таблиці'), icon: '#b953', action: setHidenCols },
        { name: localestr('Фільтр'), icon: '#b955', action: filter },
        { name: localestr('Проводки документа'), icon: '#postBut', action: objEntries },
      ]
    )




  let weightBtn = null
  //if(wndData.currentCol && wndData.currentCol.good && wndData.currentCol.good.unit && parseInt(wndData.currentCol.good.unit.value)===2) weightBtn=
  if (edit && wndData.currentCol && wndData.currentCol.unit && parseInt(wndData.currentCol.unit.value) === 2) weightBtn =
    <div id='modal' tabIndex='0' onClick={() => { weightClick() }} onKeyUp={(e) => { if (e.key === 'Enter') weightClick() }}
      style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '95px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '103px 30px' }}>
      <img style={{ width: '12px', height: '24px', verticalAlign: 'middle', marginLeft: '12px', marginRight: '8px' }} src={icon + '#run'} alt={localestr('Вага')} />
      {localestr('Вага')}
    </div>

  let payedBtn = null
  if (parseInt(wndData.payed)) payedBtn =
    window.innerWidth <= 425 ? (
      <div style={{ margin: '2px 0', display: 'inherit', flexDirection: 'column' }}>
        <EditCtrl Capt={localestr('Каса / Рахунок')} title={localestr('Звідки оплачено кошти постачальнику')}
          Value={wndData.cashAcc} typeVal={'catCashAccs'} setVal={(d) => { setValue('cashAcc', d) }} width1='120' width2='80' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Стаття')} title={localestr('На якій статті у звіті про рух коштів буде відображено цю оплату')}
          Value={wndData.article} typeVal={'catArticles'} setVal={(d) => { setValue('article', d) }} width1='120' width2='80' />
      </div>
    ) : (
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <EditCtrl Capt={localestr('Каса / Рахунок')} title={localestr('Звідки оплачено кошти постачальнику')}
          Value={wndData.cashAcc} typeVal={'catCashAccs'} setVal={(d) => { setValue('cashAcc', d) }} width1='110' width2='306' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Стаття')} title={localestr('На якій статті у звіті про рух коштів буде відображено цю оплату')}
          Value={wndData.article} typeVal={'catArticles'} setVal={(d) => { setValue('article', d) }} width1='48' width2='320' />
      </div>
    )

  let documBtn = null
  if (wndData.docum && wndData.docum.id) documBtn = <Docum data={wndData.docum} setData={tabNew} msg={msg} />

  if (window.innerWidth < 425) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', margin: '4px 5px 0 5px', height: 'calc(100% - 30px)', outline: 'none', width: 'calc(100% - 30px)' }} tabIndex='0' id='doc_cont'
        ref={el => { setActive(el); return targetRef }} onKeyUp={getSymbol}>
        <div style={{ margin: '2px 0', flexDirection: 'column', gap: '10px', display: 'inherit' }}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <EditCtrl Capt={localestr('Поступлення') + ' №'} Value={wndData.id} typeVal={'text'} setVal={(d) => { setValue('id', d) }} width1='110' width2='3' disabled={true} />
            <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
            <EditCtrl Capt={localestr('від')} title={localestr('Дата отримання товару')}
              disabled={posted} Value={new Date(wndData.date)} typeVal={'datetime'} setVal={(d) => { setValue('date', d) }} width1='30' width2='75' />
            <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px', width: '100%', justifyContent: 'space-between' }}></div>
          </div>

        </div>
        <Panel caption={''} width={180} open={wndData.p_head === undefined ? false : wndData.p_head} setOpen={d => setWndData({ ...wndData, p_head: d })}>
          {payedBtn}{documBtn}
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <EditCtrl Capt={localestr('Контрагент')} title={localestr('Від кого отримано товар')}
              disabled={posted} Value={wndData.counterpartie} typeVal={'catCounterparties'} setVal={(d) => { setValue('counterpartie', d) }} width1='80' width2='20' />
            <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
            <EditCtrl Capt={localestr('Оплачено')} title={localestr('Постачальнику одразу оплачено. В цьому випадку створювати ордер на оплату не потрібно. Але якщо дата оплати відрізняється від дати приходу, введіть ордер на підставі цього документу і не використовуйте галочку "Оплачено", щоб уникнути подвійної оплати')}
              disabled={posted} Value={wndData.payed} typeVal={'check'} setVal={(d) => { setValue('payed', d) }} width1='70' width2='20' />
          </div>
          <div style={{ margin: '2px 0', display: 'inherit', flexDirection: 'column' }}>
            <EditCtrl Capt={localestr('Вхідний ') + ' №'} title={localestr('Номер зазначений у прихідній накладній')}
              disabled={posted} Value={wndData.in_num} typeVal={'text'} setVal={(d) => { setValue('in_num', d) }} width1='200' width2='6' />
            <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
            <EditCtrl Capt={localestr('дата')} title={localestr('Дата зазначена у прихідній накладній')}
              disabled={posted} Value={wndData.in_date} typeVal={'date'} setVal={(d) => { setValue('in_date', d) }} width1='200' width2='40' />
            <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
            <EditCtrl Capt={localestr('Примітка')} disabled={posted} Value={wndData.note} typeVal={'text'} setVal={(d) => { setValue('note', d) }} width1='120' width2='100' />
          </div>
          <div style={{ margin: '2px 0', display: 'inherit', flexDirection: 'column' }}>
            <EditCtrl Capt={localestr('Підрозділ')} title={localestr('Підрозділ (склад) куди має бути оприбуткований товар')}
              disabled={posted} Value={wndData.department} typeVal={'catDepartments'} setVal={(d) => { setValue('department', d) }} width1='118' width2='100' />
            <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
            <EditCtrl Capt={localestr('Фіскалізація на')} title={localestr('Який ФОП буде здійснювати офіційний продаж товару')}
              disabled={posted} Value={wndData.fiscal} typeVal={'catDevices'} setVal={(d) => { setValue('fiscal', d) }} width1='120' width2='120' />
          </div>
        </Panel>
        <div className='toolBar no-print'>
          <div tabIndex='0' className='toolBarItem' title={localestr('Додати') + ' (Ins)'}
            onClick={() => newItem()}
            onKeyUp={(e) => { if (e.key === 'Enter') newItem() }}><img src={icon + '#addBut'} alt={localestr('Додати')} /></div>

          <div tabIndex='0' className='toolBarItem' title={localestr('Видалити') + ' (Del)'}
            onClick={() => removeItem()}
            onKeyUp={(e) => { if (e.key === 'Enter') removeItem() }}><img src={icon + '#delBut'} alt={localestr('Видалити')} /></div>

          <div tabIndex='0' className='toolBarSeparator'></div>

          {ex_btn}
          <div style={{ position: 'relative', padding: '3px' }}>
            <input id='search' type='text' value={wndData.findText || ''} onChange={(e) => { findItem(e.target.value) }} onKeyUp={keyHandler}
              onBlur={() => { setTimeout(() => { if (findDlg) setWndData({ ...wndData, findArr: null, currFind: undefined }) }, 200) }} placeholder={localestr('пошук')}
              style={{ width: '100px', padding: '0 22px 0 2px', flexShrink: '0', fontSize: 'inherit', fontFamily: 'inherit' }} />
            <img src={icon + '#b956'} alt='' style={{ position: 'absolute', right: '7px', top: '9px', width: '14px', height: '14px', opacity: 0.5 }} />
            {findItems}
          </div>
          <div tabIndex='0' className='toolBarItem' title={localestr('Підбір')}
            onClick={() => selectionClick()}
            onKeyUp={(e) => { if (e.key === 'Enter') selectionClick() }}><img src={icon + '#selBut'} alt={localestr('Підбір')} /></div>
          <div style={{ flexGrow: '10' }}></div>
          <div className='toolBarItem' title={localestr('Додатково')}>
            <Menu data={menuData}>
              <img className='toolBarIcon' src={icon + '#dnBut'} alt='' />
            </Menu>
          </div>
        </div>
        <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={{ ...wndData.currentCol, edit: isActive2 }} sorting={sorting} filter={wndData.filter} filtArr={filterData} showFilter={wndData.showAFilter} clickSort={sortList} clickHandle={(item) => { setCol(item) }} openHandle={editClick} keyHandle={anyKey} saveHandle={saveValue} cancelHandle={cancelEdit} setFilter={setFilter} tblPos={tblPos} needFocus={needFocus} />
        <div style={{ display: 'flex' }}>
          <div className='no-print' style={{ margin: '2px 0', display: 'inherit' }}>
            <div style={{ width: '70px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => saveDoc()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>OK</div></div>
            
            {gems ? <div style={{ width: '85px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => aiFillClick()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Запов. ШІ')}</div></div> : null}
          </div>
          <div style={{ flexGrow: '10' }}></div>
          <div>{ttlSum}</div>
        </div>
        <div className='no-print'>{showFilter}</div>
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', margin: '4px 0', height: 'calc(100% - 10px)', outline: 'none', width: 'calc(100% - 6px)' }} tabIndex='0' id='doc_cont'
      ref={el => { setActive(el); return targetRef }} onKeyUp={getSymbol}>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <EditCtrl Capt={localestr('Поступлення') + ' №'} Value={wndData.id} typeVal={'text'} setVal={(d) => { setValue('id', d) }} width1='122' width2='66' disabled={true} />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('від')} title={localestr('Дата отримання товару')}
          disabled={posted} Value={new Date(wndData.date)} typeVal={'datetime'} setVal={(d) => { setValue('date', d) }} width1='24' width2='168' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Контрагент')} title={localestr('Від кого отримано товар')}
          disabled={posted} Value={wndData.counterpartie} typeVal={'catCounterparties'} setVal={(d) => { setValue('counterpartie', d) }} width1='84' width2='206' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Оплачено')} title={localestr('Постачальнику одразу оплачено. В цьому випадку створювати ордер на оплату не потрібно. Але якщо дата оплати відрізняється від дати приходу, введіть ордер на підставі цього документу і не використовуйте галочку "Оплачено", щоб уникнути подвійної оплати')}
          disabled={posted} Value={wndData.payed} typeVal={'check'} setVal={(d) => { setValue('payed', d) }} width1='78' width2='20' />
      </div>
      <Panel caption={''} width={792} open={wndData.p_head === undefined ? true : wndData.p_head} setOpen={d => setWndData({ ...wndData, p_head: d })}>
        {payedBtn}{documBtn}
        <div style={{ margin: '2px 0', display: 'inherit' }}>
          <EditCtrl Capt={localestr('Вхідний ') + ' №'} title={localestr('Номер зазначений у прихідній накладній')}
            disabled={posted} Value={wndData.in_num} typeVal={'text'} setVal={(d) => { setValue('in_num', d) }} width1='84' width2='120' />
          <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
          <EditCtrl Capt={localestr('дата')} title={localestr('Дата зазначена у прихідній накладній')}
            disabled={posted} Value={wndData.in_date} typeVal={'date'} setVal={(d) => { setValue('in_date', d) }} width1='34' width2='106' />
          <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
          <EditCtrl Capt={localestr('Примітка')} disabled={posted} Value={wndData.note} typeVal={'text'} setVal={(d) => { setValue('note', d) }} width1='72' width2='360' />
        </div>
        <div style={{ margin: '2px 0', display: 'inherit' }}>
          <EditCtrl Capt={localestr('Підрозділ')} title={localestr('Підрозділ (склад) куди має бути оприбуткований товар')}
            disabled={posted} Value={wndData.department} typeVal={'catDepartments'} setVal={(d) => { setValue('department', d) }} width1='80' width2='190' />
          <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
          <EditCtrl Capt={localestr('Фіскалізація на')} title={localestr('Який ФОП буде здійснювати офіційний продаж товару')}
            disabled={posted} Value={wndData.fiscal} typeVal={'catDevices'} setVal={(d) => { setValue('fiscal', d) }} width1='110' width2='190' />
        </div>
      </Panel>
      <div className='toolBar no-print'>
        <div tabIndex='0' className='toolBarItem' title={localestr('Додати') + ' (Ins)'}
          onClick={() => newItem()}
          onKeyUp={(e) => { if (e.key === 'Enter') newItem() }}><img src={icon + '#addBut'} alt={localestr('Додати')} /></div>
        <div tabIndex='0' className='toolBarItem' title={localestr('Копіювати') + ' (F9)'}
          onClick={() => copyItem()} onKeyUp={(e) => { if (e.key === 'Enter') copyItem() }}
        ><img src={icon + '#copyBut'} alt={localestr('Копіювати')} /></div>

        <div tabIndex='0' className='toolBarItem' title={localestr('Видалити') + ' (Del)'}
          onClick={() => removeItem()}
          onKeyUp={(e) => { if (e.key === 'Enter') removeItem() }}><img src={icon + '#delBut'} alt={localestr('Видалити')} /></div>

        <div tabIndex='0' className='toolBarItem' title={localestr('Автофільтр')}
          onClick={() => showHideFilter()}
          onKeyUp={(e) => { if (e.key === 'Enter') showHideFilter() }}><img src={icon + '#filtBut'} alt={localestr('Автофільтр')} /></div>
        <div tabIndex='0' className='toolBarSeparator'></div>
        {weightBtn}
        <div tabIndex='0' onClick={() => { selectionClick() }} onKeyUp={(e) => { if (e.key === 'Enter') selectionClick() }}
          style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '95px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px' }}>
          <img style={{ width: '24px', height: '24px', verticalAlign: 'middle' }} src={icon + '#sel'} alt={localestr('Підбір')} />&nbsp;
          {localestr('Підбір')}
        </div>
        {ex_btn}
        <div tabIndex='0' className='toolBarSeparator'></div>
        <div style={{ position: 'relative', padding: '3px' }}>
          <input id='search' type='text' value={wndData.findText || ''} onChange={(e) => { findItem(e.target.value) }} onKeyUp={keyHandler}
            onBlur={() => { setTimeout(() => { if (findDlg) setWndData({ ...wndData, findArr: null, currFind: undefined }) }, 200) }} placeholder={localestr('пошук')}
            style={{ width: 'calc(100% - 28px)', padding: '0 22px 0 2px', flexShrink: '0', fontSize: 'inherit', fontFamily: 'inherit' }} />
          <img src={icon + '#b956'} alt='' style={{ position: 'absolute', right: '7px', top: '9px', width: '14px', height: '14px', opacity: 0.5 }} />
          {findItems}
        </div>
        <div style={{ flexGrow: '10' }}></div>
        <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
          <img className='toolBarIcon' src={icon + '#dnBut'} alt='' />
        </Menu></div>
      </div>
      <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={{ ...wndData.currentCol, edit: isActive2 }} sorting={sorting} filter={wndData.filter} filtArr={filterData} showFilter={wndData.showAFilter} clickSort={sortList} clickHandle={(item) => { setCol(item) }} openHandle={editClick} keyHandle={anyKey} saveHandle={saveValue} cancelHandle={cancelEdit} setFilter={setFilter} tblPos={tblPos} needFocus={needFocus} />
      <div style={{ display: 'flex' }}>
        <div className='no-print' style={{ margin: '2px 0', display: 'inherit' }}>
          <div style={{ width: '80px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => saveDoc()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>OK</div></div>
          <div style={{ width: '100px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => saveDoc(null, false)}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Зберегти')}</div></div>
          {gems ? <div style={{ width: '140px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => aiFillClick()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Заповнити з ШІ')}</div></div> : null}
        </div>
        <div style={{ flexGrow: '10' }}></div>
        <div>{ttlSum}</div>
      </div>
      <div className='no-print'>{showFilter}</div>
    </div>
  )

}

export default DocSupplyEdit